export default __webpack_public_path__ + "static/media/sabonRoman.3f067abc.ttf";